export default [{
	id: 'B-01',
	name: 'Building 1, Block B',
	lng: 118.04426112143537,
	lat: 24.61480819624786,
	height: 110.52254435303254,
	'rent': 90,
	// 平均租金
	'price': '20 yuan/m²',

	range: [
		[118.04398234085313, 24.61475631951799],
		[118.0444516949919, 24.615076456513748],
		[118.04480564340076, 24.614658245810364],
		[118.04434429544777, 24.614328450494202]
	],

	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
},
{
	id: 'B-02',
	name: 'Building 2, Block B',
	lng: 118.04362023582286,
	lat: 24.61477162241997,
	height: 138.53972862655178,
	'rent': 95,

	'price': '20 yuan/m²',
	range: [
		[118.04315721889773, 24.614940261199212],
		[118.04382620353579, 24.615393982031613],
		[118.04433687254098, 24.61479890295959],
		[118.04367858192785, 24.61433534249542]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
},
{
	id: 'B-03',
	name: 'Building 3, Block B',
	lng: 118.04216843285877,
	lat: 24.613756683677504,
	height: 138.33362989481594,
	'rent': 100,

	'price': '20 yuan/m²',
	range: [
		[118.04167613506976, 24.613786017685065],
		[118.04230201945892, 24.614225877284888],
		[118.04277692147235, 24.613673956657447],
		[118.04215383369257, 24.613221451483412]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
},
{
	id: 'B-04',
	name: 'Building 4, Block B',
	lng: 118.04210290224367,
	lat: 24.613212849140893,
	height: 110.36687581964769,
	'rent': 90,

	'price': '20 yuan/m²',
	range: [
		[118.04173256236145, 24.61318657111326],
		[118.04211612867029, 24.613458727034427],
		[118.04241565419235, 24.613114247638777],
		[118.04204251086286, 24.612830837662646]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
},
{
	id: 'B-08',
	name: 'Building 8, Block B',
	lng: 118.04107870124719,
	lat: 24.61744591529768,
	height: 121.38540558510914,
	'rent': 15,

	'price': '20 yuan/m²',
	range: [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
},
{
	id: 'B-09',
	name: 'Building 9, Block B',
	lng: 118.04100466065316,
	lat: 24.618246784634763,
	height: 114.32355701857865,
	'rent': 10,

	'price': '20 yuan/m²',
	range: [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
},
{
	id: 'B-10',
	name: 'Building 10, Block B',
	lng: 118.04020340268265,
	lat: 24.618614305240403,
	height: 122.67030496494216,
	'rent': 20,

	'price': '20 yuan/m²',
	range: [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
},
{
	id: 'B-11',
	name: 'Building 11, Block B',
	lng: 118.03975692005874,
	lat: 24.61582469830452,
	height: 124.55078306359768,
	'rent': 40,

	'price': '20 yuan/m²',
	range: [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
}, {
	id: 'B-12',
	name: 'Building 12, Block B',
	lng: 118.04043587629141,
	lat: 24.616439657927728,
	height: 95.71489727902217,
	'rent': 100,

	'price': '20 yuan/m²',
	range: [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
}, {
	id: 'B-13',
	name: 'Building 13, Block B',
	lng: 118.03960412709534,
	lat: 24.61706339491762,
	height: 124.71994336359883,
	'rent': 50,

	'price': '20 yuan/m²',
	range: [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
}, {
	id: 'B-14',
	name: 'Building 14, Block B',
	lng: 118.0393256607742,
	lat: 24.6176655998473,
	height: 94.95485096997403,
	'rent': 65,

	'price': '20 yuan/m²',
	range: [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
}, {
	id: 'B-15',
	name: 'Building 15, Block B',
	lng: 118.03864003559977,
	lat: 24.6171220425023,
	height: 125.73564309978788,
	'rent': 83,

	'price': '20 yuan/m²',
	range: [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
},
{
	'id': 'B-16',
	'name': 'Building 16, Block B',
	'lng': 118.04027934288409,
	'lat': 24.619725170727015,
	'height': 97.55356185767201,
	'rent': 60,

	'price': '20 yuan/m²',
	'range': [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
}, {
	'id': 'B-17',
	'name': 'Building 17, Block B',
	'lng': 118.04000550204573,
	'lat': 24.620236042913625,
	'height': 95.6340806433513,
	'rent': 80,

	'price': '20 yuan/m²',
	'range': [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
}, {
	'id': 'B-18',
	'name': 'Building 18, Block B',
	'lng': 118.03945251640323,
	'lat': 24.620718904106457,
	'height': 95.87233802216223,
	'rent': 70,

	'price': '20 yuan/m²',
	'range': [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
}, {
	'id': 'B-19',
	'name': 'Building 19, Block B',
	'lng': 118.03946066855782,
	'lat': 24.619321034089637,
	'height': 121.34032240774135,
	'rent': 67,

	'price': '20 yuan/m²',
	'range': [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
},
{
	'id': 'B-20',
	'name': 'Building 20, Block B',
	'lng': 118.03838164789346,
	'lat': 24.61860222985083,
	'height': 126.64137706718418,
	'rent': 50,

	'price': '20 yuan/m²',
	'range': [
		[],
		[],
		[],
		[]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
}, {
	'id': 'B-21',
	'name': 'Building 21, Block B',
	'lng': 118.03735199108111,
	'lat': 24.61848440272771,
	'height': 126.87368795511264,
	'rent': 95,

	'price': '20 yuan/m²',
	'range': [
		[118.03734790121312, 24.617998972159597],
		[118.037859549643, 24.61834767853752],
		[118.03746484683701, 24.618832037428948],
		[118.03695575444071, 24.618468492559494]
	],
	enterprises: [
		{
			"name": "Hightopo",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Xiamen HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Shanghai HT",
			"bgVisible": true,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Tianjin HT",
			"bgVisible": false,
			"legalPerson": "Li *",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Qingdao HT",
			"bgVisible": true,
			"legalPerson": "Yu*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Dalian HT",
			"bgVisible": false,
			"legalPerson": "Bo*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Chengdu HT",
			"bgVisible": true,
			"legalPerson": "Zheng*",
			"peopleNumber": "150",
			"area": "2500 m³"
		},
		{
			"name": "Beijing HT",
			"bgVisible": false,
			"legalPerson": "Lin *",
			"peopleNumber": "150",
			"area": "2500 m³"
		}
	]
}
];